import { isGulpOrBranching } from 'owa-querystring';
import { isFeatureEnabled } from 'owa-feature-flags';
import strings from 'owa-strings/owa-floodgate-survey-strings';

export type SurveyActivityType =
    | 'SearchExecuted'
    | 'AppointmentCreated'
    | 'MeetingCreated'
    | 'AppointmentUpdated'
    | 'MeetingUpdated'
    | 'MeetingCanceled'
    | 'EventViewed';

const enum StringsPlaceHolders {
    SEA_Prompt_Title = 'SEA_Prompt_Title',
    SEA_Prompt_Question = 'SEA_Prompt_Question',
    SEA_Prompt_YesLabel = 'SEA_Prompt_YesLabel',
    SEA_Prompt_NoLabel = 'SEA_Prompt_NoLabel',
    SEA_Rating_Question = 'SEA_Rating_Question',
    SEA_Rating_Values_1 = 'SEA_Rating_Values_1',
    SEA_Rating_Values_2 = 'SEA_Rating_Values_2',
    SEA_Rating_Values_3 = 'SEA_Rating_Values_3',
    SEA_Rating_Values_4 = 'SEA_Rating_Values_4',
    SEA_Rating_Values_5 = 'SEA_Rating_Values_5',
    SEA_Question_Question = 'SEA_Question_Question',
    CAL_Prompt_Title = 'CAL_Prompt_Title',
    CAL_Prompt_Question = 'CAL_Prompt_Question',
    CAL_Prompt_YesLabel = 'CAL_Prompt_YesLabel',
    CAL_Prompt_NoLabel = 'CAL_Prompt_NoLabel',
    CAL_Rating_Question = 'CAL_Rating_Question',
    CAL_Rating_Values_1 = 'CAL_Rating_Values_1',
    CAL_Rating_Values_2 = 'CAL_Rating_Values_2',
    CAL_Rating_Values_3 = 'CAL_Rating_Values_3',
    CAL_Rating_Values_4 = 'CAL_Rating_Values_4',
    CAL_Rating_Values_5 = 'CAL_Rating_Values_5',
    CAL_Question_Question = 'CAL_Question_Question',
}

export const SurveyStringMap: { [stringPlaceHolder: string]: () => string } = {
    [StringsPlaceHolders.SEA_Prompt_Title]: () => strings.promptTitle,
    [StringsPlaceHolders.SEA_Prompt_Question]: () => strings.promptDescription,
    [StringsPlaceHolders.SEA_Prompt_YesLabel]: () => strings.promptYesLabel,
    [StringsPlaceHolders.SEA_Prompt_NoLabel]: () => strings.promptNoLabel,
    [StringsPlaceHolders.SEA_Rating_Question]: () => strings.ratingQuestion,
    [StringsPlaceHolders.SEA_Rating_Values_1]: () => strings.ratingTitle1,
    [StringsPlaceHolders.SEA_Rating_Values_2]: () => strings.ratingTitle2,
    [StringsPlaceHolders.SEA_Rating_Values_3]: () => strings.ratingTitle3,
    [StringsPlaceHolders.SEA_Rating_Values_4]: () => strings.ratingTitle4,
    [StringsPlaceHolders.SEA_Rating_Values_5]: () => strings.ratingTitle5,
    [StringsPlaceHolders.SEA_Rating_Values_5]: () => strings.ratingTitle5,
    [StringsPlaceHolders.SEA_Question_Question]: () => strings.moreInfoText,
    [StringsPlaceHolders.CAL_Prompt_Title]: () => strings.calendarSurveyPromptTitle,
    [StringsPlaceHolders.CAL_Prompt_Question]: () => strings.promptDescription,
    [StringsPlaceHolders.CAL_Prompt_YesLabel]: () => strings.promptYesLabel,
    [StringsPlaceHolders.CAL_Prompt_NoLabel]: () => strings.promptNoLabel,
    [StringsPlaceHolders.CAL_Rating_Question]: () => strings.calendarSurveyRatingQuestion,
    [StringsPlaceHolders.CAL_Rating_Values_1]: () => strings.ratingTitle1,
    [StringsPlaceHolders.CAL_Rating_Values_2]: () => strings.ratingTitle2,
    [StringsPlaceHolders.CAL_Rating_Values_3]: () => strings.ratingTitle3,
    [StringsPlaceHolders.CAL_Rating_Values_4]: () => strings.ratingTitle4,
    [StringsPlaceHolders.CAL_Rating_Values_5]: () => strings.ratingTitle5,
    [StringsPlaceHolders.CAL_Rating_Values_5]: () => strings.ratingTitle5,
    [StringsPlaceHolders.CAL_Question_Question]: () => strings.moreInfoText,
};

/**
 * For documentation and definition of the campaigns for floodgate, please see documentation at:
 * https://microsoft.sharepoint.com/teams/Office_CLE/officecustomervoice/SitePages/Office%20Feedback%20SDK%20-%20Web%20-%20Floodgate.aspx
 * https://microsoft.sharepoint.com/teams/Office_CLE/officecustomervoice/SitePages/Office%20Floodgate%20SDK.aspx
 */
export const surveryCampaignDefinitions = [
    {
        CampaignId: '2297b804-90bb-44c4-a0d4-73a8da24b81c',
        StartTimeUtc: '2018-06-01T00:00:00Z',
        EndTimeUtc: '2023-06-01T00:00:00Z',
        GovernedChannelType: 0,
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() || isFeatureEnabled('sea-floodgateSurveySDFSampling') ? 100 : 5,
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'SearchExecuted',
                        Count: 1,
                        IsAggregate: true,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.SEA_Prompt_Title,
                    Question: StringsPlaceHolders.SEA_Prompt_Question,
                    YesLabel: StringsPlaceHolders.SEA_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.SEA_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.SEA_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.SEA_Rating_Values_1,
                        StringsPlaceHolders.SEA_Rating_Values_2,
                        StringsPlaceHolders.SEA_Rating_Values_3,
                        StringsPlaceHolders.SEA_Rating_Values_4,
                        StringsPlaceHolders.SEA_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.SEA_Question_Question },
            },
        },
    },
    {
        CampaignId: '67e861da-9c21-4cc3-aaed-dc87c39a6e99',
        StartTimeUtc: '2018-07-01T00:00:00Z',
        EndTimeUtc: '2023-07-01T00:00:00Z',
        GovernedChannelType: 0,
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() || isFeatureEnabled('cal-surveyCreateApptBucket') ? 100 : 0,
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'AppointmentCreated',
                        Count: 2,
                        IsAggregate: true,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.CAL_Prompt_Title,
                    Question: StringsPlaceHolders.CAL_Prompt_Question,
                    YesLabel: StringsPlaceHolders.CAL_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.CAL_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.CAL_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.CAL_Rating_Values_1,
                        StringsPlaceHolders.CAL_Rating_Values_2,
                        StringsPlaceHolders.CAL_Rating_Values_3,
                        StringsPlaceHolders.CAL_Rating_Values_4,
                        StringsPlaceHolders.CAL_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.CAL_Question_Question },
            },
        },
    },
    {
        CampaignId: '579612b7-b210-43d2-b7d6-7251f316beed',
        StartTimeUtc: '2018-07-01T00:00:00Z',
        EndTimeUtc: '2023-07-01T00:00:00Z',
        GovernedChannelType: 0,
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() || isFeatureEnabled('cal-surveyCreateMeetBucket') ? 100 : 0,
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'MeetingCreated',
                        Count: 2,
                        IsAggregate: true,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.CAL_Prompt_Title,
                    Question: StringsPlaceHolders.CAL_Prompt_Question,
                    YesLabel: StringsPlaceHolders.CAL_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.CAL_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.CAL_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.CAL_Rating_Values_1,
                        StringsPlaceHolders.CAL_Rating_Values_2,
                        StringsPlaceHolders.CAL_Rating_Values_3,
                        StringsPlaceHolders.CAL_Rating_Values_4,
                        StringsPlaceHolders.CAL_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.CAL_Question_Question },
            },
        },
    },
    {
        CampaignId: '90c124f5-fd59-4711-9857-5892e4a76281',
        StartTimeUtc: '2018-07-01T00:00:00Z',
        EndTimeUtc: '2023-07-01T00:00:00Z',
        GovernedChannelType: 0,
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() || isFeatureEnabled('cal-surveyUpdateApptBucket') ? 100 : 0,
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'AppointmentUpdated',
                        Count: 1,
                        IsAggregate: true,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.CAL_Prompt_Title,
                    Question: StringsPlaceHolders.CAL_Prompt_Question,
                    YesLabel: StringsPlaceHolders.CAL_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.CAL_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.CAL_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.CAL_Rating_Values_1,
                        StringsPlaceHolders.CAL_Rating_Values_2,
                        StringsPlaceHolders.CAL_Rating_Values_3,
                        StringsPlaceHolders.CAL_Rating_Values_4,
                        StringsPlaceHolders.CAL_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.CAL_Question_Question },
            },
        },
    },
    {
        CampaignId: '1d342f09-77ae-414c-8f11-790d087f9529',
        StartTimeUtc: '2018-07-01T00:00:00Z',
        EndTimeUtc: '2023-07-01T00:00:00Z',
        GovernedChannelType: 0,
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() || isFeatureEnabled('cal-surveyUpdateMeetBucket') ? 100 : 0,
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'MeetingUpdated',
                        Count: 2,
                        IsAggregate: true,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.CAL_Prompt_Title,
                    Question: StringsPlaceHolders.CAL_Prompt_Question,
                    YesLabel: StringsPlaceHolders.CAL_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.CAL_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.CAL_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.CAL_Rating_Values_1,
                        StringsPlaceHolders.CAL_Rating_Values_2,
                        StringsPlaceHolders.CAL_Rating_Values_3,
                        StringsPlaceHolders.CAL_Rating_Values_4,
                        StringsPlaceHolders.CAL_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.CAL_Question_Question },
            },
        },
    },
    {
        CampaignId: 'dfdee7bb-9c94-43b0-85c6-edd17aa0f6ab',
        StartTimeUtc: '2018-07-01T00:00:00Z',
        EndTimeUtc: '2023-07-01T00:00:00Z',
        GovernedChannelType: 0,
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() || isFeatureEnabled('cal-surveyCancelMeetBucket') ? 100 : 0,
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'MeetingCanceled',
                        Count: 1,
                        IsAggregate: true,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.CAL_Prompt_Title,
                    Question: StringsPlaceHolders.CAL_Prompt_Question,
                    YesLabel: StringsPlaceHolders.CAL_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.CAL_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.CAL_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.CAL_Rating_Values_1,
                        StringsPlaceHolders.CAL_Rating_Values_2,
                        StringsPlaceHolders.CAL_Rating_Values_3,
                        StringsPlaceHolders.CAL_Rating_Values_4,
                        StringsPlaceHolders.CAL_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.CAL_Question_Question },
            },
        },
    },
    {
        CampaignId: 'b173aebc-cb92-43bd-96d7-3300c35e68b7',
        StartTimeUtc: '2018-07-01T00:00:00Z',
        EndTimeUtc: '2023-07-01T00:00:00Z',
        GovernedChannelType: 0,
        NominationScheme: {
            Type: 0,
            PercentageNumerator:
                isGulpOrBranching() || isFeatureEnabled('cal-surveyViewEventBucket') ? 100 : 0,
            PercentageDenominator: 100,
            NominationPeriod: { Type: 0, IntervalSeconds: 2592000 },
            CooldownPeriod: { Type: 0, IntervalSeconds: 7776000 },
        },
        SurveyTemplate: {
            Type: 2, // FPS
            ActivationEvent: {
                Type: 1,
                Sequence: [
                    {
                        Type: 0,
                        Activity: 'EventViewed',
                        Count: 2,
                        IsAggregate: true,
                    },
                ],
            },
            Content: {
                Prompt: {
                    Title: StringsPlaceHolders.CAL_Prompt_Title,
                    Question: StringsPlaceHolders.CAL_Prompt_Question,
                    YesLabel: StringsPlaceHolders.CAL_Prompt_YesLabel,
                    NoLabel: StringsPlaceHolders.CAL_Prompt_NoLabel,
                },
                Rating: {
                    Question: StringsPlaceHolders.CAL_Rating_Question,
                    RatingValuesAscending: [
                        StringsPlaceHolders.CAL_Rating_Values_1,
                        StringsPlaceHolders.CAL_Rating_Values_2,
                        StringsPlaceHolders.CAL_Rating_Values_3,
                        StringsPlaceHolders.CAL_Rating_Values_4,
                        StringsPlaceHolders.CAL_Rating_Values_5,
                    ],
                },
                Question: { Question: StringsPlaceHolders.CAL_Question_Question },
            },
        },
    },
];
